package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.merkost.handpass.sharedweb.theme.AnimNames
import com.merkost.handpass.sharedweb.theme.Border
import com.merkost.handpass.sharedweb.theme.Dur
import com.merkost.handpass.sharedweb.theme.Ease
import com.merkost.handpass.sharedweb.theme.LayoutDrawerWidth
import com.merkost.handpass.sharedweb.theme.Overlay
import com.merkost.handpass.sharedweb.theme.Surface
import com.merkost.handpass.sharedweb.theme.WebSize
import com.merkost.handpass.sharedweb.theme.ZDrawer
import com.merkost.handpass.sharedweb.theme.ZDrawerBackdrop
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Overflow
import org.jetbrains.compose.web.css.AnimationFillMode
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

val WebDrawerBackdropStyle = CssStyle.base {
    Modifier
        .position(Position.Fixed)
        .styleModifier { property("inset", "0") }
        .backgroundColor(Overlay.value())
        .styleModifier { property("z-index", ZDrawerBackdrop.value().toString()) }
}

val WebDrawerPanelStyle = CssStyle.base {
    Modifier
        .position(Position.Fixed)
        .top(WebSize.P0.value())
        .left(WebSize.P0.value())
        .bottom(WebSize.P0.value())
        .width(LayoutDrawerWidth.value())
        .backgroundColor(Surface.value())
        .borderRight(WebSize.P1.value(), LineStyle.Solid, Border.value())
        .overflow { y(Overflow.Auto) }
        .styleModifier { property("z-index", ZDrawer.value().toString()) }
        .animation(
            Animation.of(
                name = AnimNames.DrawerIn,
                duration = Dur.Slow,
                timingFunction = Ease.Standard,
                iterationCount = AnimationIterationCount.of(1),
                fillMode = AnimationFillMode.Forwards,
            )
        )
}

@Composable
fun WebDrawer(onDismiss: () -> Unit, ariaLabel: String? = null, content: @Composable () -> Unit) {
    var panelEl by remember { mutableStateOf<HTMLElement?>(null) }
    WebDialogFocusScope(container = panelEl, onDismiss = onDismiss)

    Div(
        attrs = WebDrawerBackdropStyle.toModifier().toAttrs {
            onClick { onDismiss() }
        }
    ) {}

    Div(
        attrs = WebDrawerPanelStyle.toModifier().toAttrs {
            attr("role", "dialog")
            attr("aria-modal", "true")
            attr("tabindex", "-1")
            attr("aria-label", ariaLabel ?: "Navigation drawer")
            ref { element ->
                panelEl = element
                onDispose { panelEl = null }
            }
            onClick { it.stopPropagation() }
        }
    ) {
        content()
    }
}
